var ErrorMessageStore = (function() {
    var messageSet = {};	

    var set = function(fieldId, message) {
        messageSet[fieldId] = message;
    };

    var remove = function(fieldId) {
        delete messageSet[fieldId];
        
        if (!!Object.keys(messageSet)) {
            $(".status-text").text(messageSet[Object.keys(messageSet)[0]]);
        }
    };
    
    return {
    	set : set,
    	remove : remove
    };
})();